(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/core/assets/javascripts/events/show-fullscreen-event.js') >= 0) return;  svs.modules.push('/components/onboarding/core/assets/javascripts/events/show-fullscreen-event.js');
"use strict";

const VerifyType = svs.components.tbUtils.verify.constants.VerifyType;
const verifyObject = svs.components.tbUtils.verify.verifyObject;
const BaseFullscreenEvent = svs.components.onboarding.core.events.BaseFullscreenEvent;
const FullscreenEventType = svs.components.onboarding.core.events.constants.FullscreenEventType;
class ShowFullscreenEvent extends BaseFullscreenEvent {
  constructor(props) {
    verifyObject(props).schema({
      component: VerifyType.Object
    });
    super(FullscreenEventType.Show, props);
  }
}

setGlobal('svs.components.onboarding.core.events.ShowFullscreenEvent', ShowFullscreenEvent);

 })(window);